import { Row, Col, Modal, Button, Form, message } from "antd";
import { useState } from "react";
import axios from "axios";
import { DeleteOutlined } from "@ant-design/icons";

import endpoints from "../../utils/endpoints.js";

function Delete({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const [form] = Form.useForm();

  function submit() {
    setIsButtonLoading(true);
    axios
      .post(endpoints.credits.delete, {
        data: { id: data.id },
      })
      .then((res) => {
        closeModal();
        message.success("Crédito foi apagado com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeModal() {
    close();
    setIsButtonLoading(false);
    form.resetFields();
  }

  return (
    <Modal
      className="modal-antd-program"
      title={`Apagar crédito`}
      open={open}
      onCancel={closeModal}
      footer={[
        <Button danger icon={<DeleteOutlined />} size="large" type="primary" onClick={submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Apagar
        </Button>,
        <Button size="large" onClick={closeModal}>
          Cancelar
        </Button>,
      ]}
    >
      <div className="p-4">
        <p>Tem a certeza que quer apagar o crédito:</p>
        <p className="font-bold text-lg mt-2">{data.name}</p>
      </div>
    </Modal>
  );
}

export default Delete;
